import { callable } from './callable'

export type DeleteMyTeamDataInput =
  | { scope: 'ALL' }
  | { scope: 'ONE'; workspaceId: string }

export interface DeleteMyTeamDataResult {
  ok: true
  scope: 'ALL' | 'ONE'
  exitedWorkspaces: string[]
}

export interface DeleteMyAccountResult {
  ok: true
  uid: string
}

export interface RequestAccountDeletionResult {
  ok: true
  uid: string
  purgeAfter: unknown
  requestedAt: unknown
}

export interface RestoreAccountDeletionResult {
  ok: true
  uid: string
}

export const deleteMyTeamData = async (
  input: DeleteMyTeamDataInput,
): Promise<DeleteMyTeamDataResult> => {
  return callable<DeleteMyTeamDataInput, DeleteMyTeamDataResult>('deleteMyTeamData', input)
}

export const deleteMyAccount = async (): Promise<DeleteMyAccountResult> => {
  return callable<Record<string, never>, DeleteMyAccountResult>('deleteMyAccount', {})
}

export const requestAccountDeletion = async (): Promise<RequestAccountDeletionResult> => {
  return callable<Record<string, never>, RequestAccountDeletionResult>('requestAccountDeletion', {})
}

export const restoreAccountDeletion = async (): Promise<RestoreAccountDeletionResult> => {
  return callable<Record<string, never>, RestoreAccountDeletionResult>('restoreAccountDeletion', {})
}
